export default {
    DataItemName: 'Control Name',
    Visible: 'Visible',
    ControlStyle: 'Control Style',
    ControlTips: 'Control Tips',
    LabelVisible: 'Title display',
    ControlType: 'Control Type',
    MultiLanguage: 'Multilingual',
    DataItemCode: 'DataItem Code',
    DataItemType: 'DataItem Type',
    DataDictionary: 'Data Dictionary',
    DisplayConditions: 'Display Formula',
    ChangeEvent: 'Change Event',
    RequiredFormula: 'Required Formula',
    ReadonlyConditions: 'Readonly Conditions',
    ReadonlyFormula: 'Readonly Formula',
    DefaultValue: 'Default value',
    Regex: 'Regex Verification',
    RegexErrTips: 'Regex Error Message',
    Placeholder: 'Placeholder',
    InputPlaceholder: 'Please input',
    MaxLength: 'Max length',
    DeDuplicateVerification: 'Deduplicate Verification',
    DataLinkage: 'Data Linkage',
    CalculationRules: 'Calculation Rules',
    InputByScanCode: 'Scan code input',
    InputBoxStyle: 'Input Box Style',
    WordLimit: 'Word Limit',
    DefaultValue2: 'DataItem Default',
    Format1: 'Display Format',
    SyncDefaultFormat: 'Sync Default Format',
    Format: 'Default Format',
    Minimum: 'Minimum',
    Maximum: 'Maximum',
    SubmitValidation: 'Submit Validation',
    WebDirection: 'Web Direction',
    DisplaySetting: 'Display Settings',
    Options: 'Options',
    ShowEmptyOptions: 'Show Empty Option',
    EmptyOptionsValue: 'Empty Option Value',
    SelectPlaceholder: 'Please select',
    Multi: 'Multiple Choice',
    FileTypeLimit: 'Limit File Type',
    ////二开开始 新增 csv格式文件
    FileTypeLimitTips: 'Set the file name format for uploading attachments, limited to office, picture, compressed package, etc. Examples: .jpg,.gif.<br>The following types are not supported:<br>.php.php5.php4.php3. php2.php1&nbsp;.html.htm.phtml.pHp.pHp5.pHp4.pHp3.pHp2.pHp1&nbsp;.Html.Htm.pHtml.jsp.jspa.jspx.jsw.jsv.jspf.jtml.jSp&nbsp;.jSpx.jSpa .jSw.jSv.jSpf.jHtml.asp.aspx.asa.asax&nbsp;.ascx.ashx.asmx.cer.aSp.aSpx.aSa.aSax.aScx.aShx.aSmx.cEr.sWf.swf.csv',
    //二开结束 新增 csv格式文件
    AttachmentTemplate: 'Attachment Template',
    UploadTemplate: 'Upload Template',
    FileSizeLimit: 'File Size Limit',
    BatchDownload: 'Batch Download',
    UploadEvent: 'Upload Event',
    DeleteEvent: 'Delete Event',
    UploadQuantity: 'Upload quantity',
    Watermark: 'Watermark',
    WatermarkFontSize: 'Watermark Font Size',
    ImageQuality: 'Image Quality',
    Compress: 'Compress',
    OnlyPhoto: 'Only Shoot',
    DisplayTerminal: 'Display Terminal',
    Mobile: 'Mobile',
    PreciseRange: 'Precise Range',
    DisplayType: 'Display Type',
    AutoLocation: 'Auto Location',
    LocationSearch: 'Locatino Search',
    AddressFormat: 'Address Format',
    AddressDetail: 'Address Detail',
    DisplayEmpty: 'Display Empty',
    EmptyValue: 'Empty Value',
    OptionalType: 'Optional type',
    OrgRootNode: 'Organize root node',
    RecursivelyDisplay: 'Whether recursively display',
    RoleScope: 'Role Scope',
    Mapping: 'Mappings',
    DefaultExpand: 'Default Expand',
    Align: 'Align',
    DataLimit: 'Data limit',
    BizModal: 'Select business model',
    DisplayStyle: 'Display style',
    QueryList: 'Query list',
    DisplayField: 'Display field',
    MappingField: 'Mapping field',
    QueryConditions: 'Query conditions',
    MobileQueryConditions: 'Mobile query condition',
    LinkMode: 'Show link mode',
    SelectType: 'Select method',
    ModelField: 'Popup field',
    TemporaryAuthorization: 'Temporary Authorization',
    BizModal2: 'Business Model',
    RelevanceField: 'Relevance Field',
    DisplayType2: 'Display Mode',
    RelevanceFieldType: 'Relevance field type',
    SerialCode: 'Serial code',
    ResetTime: 'Reset policy time',
    Connector: 'Connectors',
    ColumnWidth: 'Column width px',
    DefaultRows: 'Default number of rows',
    Editable: 'Editable',
    EmptyLine: 'Empty line verification',
    Importable: 'Importable',
    Emportable: 'Emportable',
    ImportFromRelevanceForm: 'Import from related form',
    DisplaySummaryRows: 'Whether to show summary rows',
    BatchEditable: 'Batcheditable',
    SheetQueryCondition: 'Sub-table filter condition',
    AddRowEvent: 'Add Row Event',
    DeleteRowEvent: 'Row deletion event',
    MobileStyle: 'Mobile style',
    SummaryMode: 'Statistical Mode',
    DefaultOptions: 'Default options',
    DefaultValueType: 'Default value type',
    RadioDefaultOptions: 'item1;item2;item3',
    Location: 'Location',
    Address: 'Address',
    ProvinceCityCounty: 'Province/City/County',
    ProvinceCity: 'Province/City',
    Province: 'province',
    Set: 'Set',
    Unset: 'Unset',
    Yes: 'Yes',
    No: 'No',
    RequiredWithConditions: 'Required if conditions are met',
    Attachment: 'Attachment',
    Image: 'Image',
    Signature: 'Signature',
    ValidityErrTips: 'Length cannot exceed {num} bytes',
    ClickOrDragUpload: 'Click or Drag Upload',
    TemplateDownload: 'Attachment template download',
    Horizontal: 'Horizontal',
    Portrait: 'Portrait',
    TickOption: 'Tick option',
    AllItems: 'All items',
    Format1Tips: 'When the text is green, it means synchronization with the default format',
    Null: 'null',
    CurrentTime: 'Current time',
    Multi2: 'Multiple choice',
    Organization: 'Organization',
    CreateBy: 'Creator',
    CreateByDept: 'Creator Department',
    Single: 'Single choice',
    Left: 'Left',
    Middle: 'Middle',
    Right: 'Right',
    Small: 'Small',
    Big: 'Big',
    Large: 'Large',
    Accurate: 'Accurate',
    Arbitrary: 'Arbitrary',
    ValidityErrTips2: 'Can only enter positive integers',
    ValidityErrTips3: 'Maximum length can not exceed {num}',
    ValidityErrTips4: 'Word limit cannot be empty',
    ValidityErrTips5: 'Maximum number of characters cannot exceed ',
    Textarea: 'Multiline Text',
    Richtext: 'Rich text',
    ValidityErrTips6: 'Only numeric type can be entered, the maximum length is 19 digits, and the precision is 3 digits',
    DataTitle: 'Data Title',
    List: 'List',
    Tree: 'Tree shape',
    PopupModal: 'Popup box',
    DropdownInput: 'Dropdown box',
    PopupField: 'Popup field',
    Readable: 'Readable',
    Selectable: 'Selectable',
    RelevanceForm: 'RelevanceForm',
    RelevanceFormMulti: 'RelevanceFormMulti',
    List2: 'List',
    Linking: 'Link',
    Tabs: 'Tabs',
    DetailList: 'Detail List',
    NotReset: 'Not reset',
    Daily: 'Daily',
    Monthly: 'Monthly',
    Yearly: 'Yearly',
    ValidityErrTips7: 'Control name cannot be empty',
    ValidityErrTips8: 'Length cannot exceed 50',
    ValidityErrTips9: 'Cannot start with spaces',
    ValidityErrTips10: 'Column width cannot be empty',
    ValidityErrTips11: 'Cannot exceed the maximum width of 885',
    ValidityErrTips12: 'Cannot be less than the minimum width of 150',
    ValidityErrTips13: 'The default number of rows cannot be empty',
    ValidityErrTips14: 'The default number of rows cannot exceed 100',
    WaterFall: 'Waterfall Style',
    TwoDimensional: 'Two-dimensional Table',
    Pageing: 'Page Style',
    NotCounted: 'Not counted',
    Summation: 'Sum',
    AverageValue: 'Average',
    User: 'User',
    All: 'All',
    SystemAutoFill: 'System auto fill',
    CheckType: 'Check Type',
    RequiredType: 'Required Type',
    NotRequired: 'Not required',
    DisplayDataItem: 'Display Data Item',
    CheckDataItem: 'Check Data Item',
    LinkageTargetModel: 'Linkage Target Model',
    LinkageTargetForm: 'Linkage Target Form',
    LinkageCondition: 'Linkage Conditions',
    CurrentModelDataItem: 'Current Model Data Item',
    LinkedModelDataItem: 'Linked Model Data Item',
    ValueEqual: 'Value equal',
    AddCondition: 'Add condition',
    LinkedFill: 'Linked Fill',
    CancelLink: 'Cancel linkage',
    NoLinkageModel: 'Please select a linkage model',
    NoLinkFill: 'The linkage fill item cannot be empty',
    LinkModelNotSame: 'Linked filling item models are not the same',
    NoCondition: 'Condition configuration item cannot be empty',
    CancelLinkTips: 'Canceling the linkage will clear the currently set linkage data, are you sure you want to cancel this data linkage? ',
    UploadTemplateTips: 'You have uploaded ',
    UploadTemplateTips2: ' templates,',
    UploadTemplateTips3: 'the number of attachment templates cannot exceed 10',
    UploadFileTemplate: 'Upload attachment template',
    ViewTemplate: 'View Template',
    UploadFileTemplateTips: '{file} file can be uploaded at maximum {num}B',
    UploadFileTemplateTips2: 'The file format is incorrect, only files in file format are supported! ',
    UploadFileTemplateTips3: 'Maximum cannot exceed 10M! ',
    UploadFileTemplateTips4: 'Up to 10 template files can be uploaded',
    EventTips: 'value: current value, oldValue: old value, form: form object',
    EventPlaceholder: 'Please enter {title} details, for example: form.text1.value = \'\'',
    OptionsSource: 'Option Source',
    SortDataItems: 'Sort data items',
    SortRule: 'Sort Rule',
    Ascending: 'Ascending A-Z',
    Descending: 'Descending Z-A',
    Default: 'Default',
    QueryDataItem: 'Query Data Item',
    ValueType: 'ValueType',
    OptionsSetting: 'Option Settings',
    BizDataItemOptionsRules: 'Business data option setting specification',
    BizDataItemOptionsSettingRule1: 'A maximum of 200 options can be checked when the form is designed, and only a maximum of 200 options can be displayed when the form is running. ',
    BizDataItemOptionsSettingRule2: 'The same option value will be filtered, leaving only one option value. For example, in the "Name" field, Zhang San, Zhang San, Li Si, the option values are Zhang San and Li Si. Duplicate values are filtered out. ',
    SelectedDataItems: 'The current data item is ',
    SelectedDataItems2: ', you have selected ',
    SelectedDataItems3: '',
    SelectedDataItems4: ', and you can choose ',
    SearchByNamePlaceholder: 'Please enter a name to search',
    DynamicValue: 'Dynamic value',
    FixedValue: 'Fixed value',
    OptionsTips: 'Select up to 200 pieces of data',
    OptionsTips2: 'Custom options cannot be empty! ',
    OptionsTips3: 'Business model cannot be empty',
    OptionsTips4: 'Data item cannot be empty',
    OptionsTips5: 'No option value selected',
    OptionsTips6: 'Cannot start with spaces! ',
    BatchSetOptions: 'Batch settings options',
    SelectDictionary: 'Select Dictionary',
    DictionaryData: 'DictionaryData',
    OptionsTips7: 'When not set, the foreground uses all dictionary data',
    LoadingData: 'Loading data...',
    DictionaryTips: 'The selected dictionary has no data items, please replace the dictionary! ',
    OptionalData: 'Optional data',
    UnMatched: 'No matching information',
    QueryRes: '{num1} records meet the query conditions, return {num2} records',
    Total: 'Total {num}',
    OptionsTips8: 'Only 200 dictionary data can be selected at most',
    OptionsTips9: 'Data dictionary cannot be empty',
    InvalidMapping: 'Invalid mapping',
    SetFormat1: 'Display format settings',
    SyncTips: 'It is consistent with the default format of the data model {model}',
    CheckType2: 'Check Type',
    SubmitCheck: 'Submit Check',
    RegularCheckRules: 'Regular check rules',
    IvalidRegex: 'The input regular is invalid',
    NoRulesErr: 'Please fill in rules',
    CheckMethod: 'Check method',
    Constant: 'Constant',
    CheckRules: 'Check Rules',
    CheckRulesTips: 'Only data items in the same display format can be selected;',
    CheckRulesTips2: 'When selecting the current day, fill in the negative number in the input box to represent the day before, zero to represent the day, and the positive number to represent the day after, the unit is days. ',
    CheckRulesPlaceholder: 'Please select a data item',
    CheckRulesPlaceholder2: 'Please enter a number',
    FailedMsg: 'Verification Failed Prompt',
    TipsPopup: 'Tips popup',
    TipsPopupTips: 'If there are too many words in the verification failure prompt, please use the long prompt pop-up box, only for the web side',
    ShortTips: 'Short tip popup',
    LongTips: 'Long tip popup',
    TipsContent: 'This is an abnormal message and will disappear automatically',
    ErrorTips: 'Error Tips',
    ErrorTipsTips: 'A series of message descriptions, which may be very long. It can also be very short and can also be punctuated. ',
    TheDay: 'The day',
    CheckRulesPlaceholder3: 'Please select a date range',
    CheckRulesErrTips: 'The check rule is invalid! ',
    CheckRulesErrTips2: 'Please enter the right boundary value! ',
    CheckRulesErrTips3: 'Please enter the left boundary value! ',
    CheckRulesErrTips4: 'Check rules, the left boundary value is invalid! ',
    CheckRulesErrTips5: 'Check rules, the right boundary value is invalid! ',
    CheckRulesErrTips6: 'Please select the right boundary value! ',
    CheckRulesErrTips7: 'Please select the left boundary value! ',
    SelectOrg: 'Organizational',
    FormField: 'Form Field',
    CreaterRelated: 'Creator related',
    SelectPlaceholder2: 'Click to select',
    Single2: 'Single sheet',
    Multiple: 'Multiple sheets',
    Minimum2: 'Minimum number',
    Maximum2: 'Maximum number',
    InvalidMinimum: 'The minimum value is invalid! ',
    InvalidMaximum: 'The maximum value is invalid! ',
    MaximunMinimunErr: 'Maximum must be greater than minimum! ',
    AddressSettng: 'Set address',
    LocationSetting: 'Set location',
    CalcularDataItem: 'Calculation data item',
    Function: 'Function',
    InsertDataItem: 'Insert data item',
    SearchDataItem: 'Search DataItem',
    SearchFunction: 'Search function',
    CheckEx: 'Check formula',
    Use: 'Usage',
    Example: 'Example',
    ClearRule: 'Clear rule',
    FunctionErr: 'The TODAY function can only be assigned to text, not to numeric values',
    ClearRuleTips: 'Clearing the rules will clear the currently set calculation rule data, are you sure you want to clear the rules? ',
    ExPlaceholder: 'Please select or enter a data item, function',
    Operator: 'Operator',
    Canceled: 'Cancelled',
    InputPlaceholder2: 'Date format 2019-05-10 12:00:00',
    InputPlaceholder3: 'Time format 12:00:00',
    InputPlaceholder4: 'Please input, multiple values are connected with ";"',
    DataLimitTips: 'Please check whether the business model is configured',
    NoSheet: 'The current model or associated model has no child sheet and cannot be mapped',
    RelevanceModelErr: 'Relevance model is unavailable, please re-select',
    NoBizModel: 'The current form does not specify a business model',
    RelevanceModelField: 'Relevance model field',
    DefaultOperator: 'Default operator',
    Value: 'Value or current form field',
    IsNull: 'Null',
    NotNull: 'NotNull',
    Variable: 'Variable',
    InputPlacholder5: 'Date format: 2019-05-10',
    QueryConditionTips: 'The associated multi-select control in the subtable does not support the mapping function',
    QueryConditionTips2: 'Please check whether the current form has been published, or the list of bindings',
    QueryConditionTips3: 'Show whether the field has the same type of data item! ',
    QueryConditionTips4: 'Have query conditions been set! ',
    AddField: 'Add field',
    CurrentFormField: 'Current form field',
    TabSetting: 'Tab setting',
    AddTab: 'Add Tab',
    TabConditionSetting: 'Tab condition setting',
    TabErrTips: 'Tab name cannot contain: double quotes and single quotes',
    Equal: 'Equal',
    NotEqual: 'NotEqual',
    Above: 'Above',
    Below: 'Below',
    NotBelow: 'NotBelow',
    NotAbove: 'NotAbove',
    Contains: 'Contains',
    NotContains: 'NotContains',
    In: 'In',
    NotIn: 'NotIn',
    Of: 'Of',
    NotOf: 'NotOf',
    Have: 'Have',
    NotHave: 'NotHave',
    ShortText: 'ShortText',
    Checkbox: 'Checkbox',
    StaffSelector: 'StaffSelector',
    DepartmentSelector: 'DepartmentSelector',
    CreatedTime: 'CreatedTime',
    Date: 'Date',
    DepartmentMultiSelector: 'DepartmentMultiSelector',
    Description: 'Description',
    Dropdown: 'Dropdown',
    DropdownMulti: 'DropdownMulti',
    Logic: 'Logic',
    LongText: 'LongText',
    ModifiedTime: 'ModifiedTime',
    Modifier: 'ModifyBy',
    Number: 'Number',
    Owner: 'Owner',
    Radio: 'Radio',
    ReverseRelevance: 'ReverseRelevance',
    SequenceNo: 'SequenceNo',
    ShortText2: 'ShortText',
    Sheet: 'Sheet',
    SheetStatistic: 'SheetStatistic',
    StaffMultiSelector: 'StaffMultiSelector',
    StaffSelectorMixed: 'StaffDeptMixed',
    Time: 'Time',
    Summary: 'Summary',
    True: 'True',
    False: 'False',
};
